<div
  class="user-message-container"
  *ngIf="userMessage && currentLang"
  style="right: 0"
>
  <div
    class="user-message-wrapper"
    [@slideInFromRightBottom]
    *ngIf="userMessage[currentLang]"
  >
    <div
      #messageBubble
      tabindex="-1"
      [style.textAlign]="textAlignment"
      class="user-message-box text-box chat-text-box user-message-bubble-text user-message-bubble"
      [innerHTML]="userMessage[currentLang]"
    ></div>
  </div>
</div>
